import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import LinkIcon from '@mui/icons-material/Link'
import { Typography, useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import ButtonBase from '@mui/material/ButtonBase'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { HOST } from '~/constants'
import { copyToClipboard } from '~/utils/utilityFunctions'

import { useCompanyCode } from '~/lib/company'

export function CompanyCodeCard() {
  const theme = useTheme()
  const { t } = useTranslation()
  const { data } = useCompanyCode()
  const [codeCopied, setCodeCopied] = useState(false)
  const [linkCopied, setLinkCopied] = useState(false)

  const handleCopy = async (setState: (value: boolean) => void, prefix = '') => {
    if (!data?.content) return

    try {
      await copyToClipboard(prefix + data.content)
      setState(true)
      setTimeout(() => setState(false), 2000)
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Failed to copy code:', err)
    }
  }

  return (
    <Box
      height={88}
      width="350px"
      borderRadius={theme.radius.M}
      bgcolor={theme.palette.common.white}
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      padding={`${theme.spacing.L} ${theme.spacing.XXL}`}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="body-small">{t('home:code.title')}</Typography>
        <Box display="flex" gap={theme.spacing['XL']}>
          <ButtonBase
            onClick={() => handleCopy(setCodeCopied)}
            sx={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Typography variant="caption" color={codeCopied ? 'success' : 'main'}>
              {codeCopied ? t('home:code.copied') : t('home:code.copy')}
            </Typography>
            <Box ml={theme.spacing.S} display="flex" alignItems="center">
              <ContentCopyIcon sx={{ fontSize: theme.size[8] }} />
            </Box>
          </ButtonBase>
          <ButtonBase
            onClick={() => handleCopy(setLinkCopied, HOST + '/users/sign_up?code=')}
            sx={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Typography variant="caption" color={linkCopied ? 'success' : 'main'}>
              {linkCopied ? t('home:code.copied') : t('home:code.link')}
            </Typography>
            <Box ml={theme.spacing.S} display="flex" alignItems="center">
              <LinkIcon sx={{ fontSize: theme.size[8] }} />
            </Box>
          </ButtonBase>
        </Box>
      </Box>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        {data?.content?.split('').map((letter, index) => (
          <Box
            key={'CompanyCodeLetter-' + index}
            width={20}
            height={28}
            borderRadius={theme.radius.M}
            display="flex"
            alignItems="center"
            justifyContent="center"
            border={
              index < 2 ? `2px solid ${theme.palette.primary.light}` : `1px solid ${theme.palette.text.mainLight}`
            }
          >
            <Typography
              variant="caption"
              sx={{
                color: index < 2 ? theme.palette.primary.main : theme.palette.text.main,
              }}
            >
              {letter.toUpperCase()}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  )
}
